import React, { useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import './Signup.css';
//import { PreLoginUUID,PostLoginUUID,getToken,saveToken } from '../utils/auth';
function ForgetPassword() {
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim() || !newPassword.trim()) {
      alert("Please fill all fields.");
      return;
    }

    try {
      const response = await fetch("http://localhost:8080/api/public/reset-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: 'PreLoginUUID',
          authType: 'PreLogin'
        },
        body: JSON.stringify({ email, password: newPassword }),
      });

      if (response.ok) {
        alert("Password updated successfully!");
        navigate("/signin");
      } else {
        const error = await response.text();
        alert("Error: " + error);
      }
    } catch (err) {
      alert("Server error.");
    }
  };

  return (
    <div className="bg-light">
      <div className="container">
        <div className="login-card">
          <div className="login-header">
            <h2>Forgot Password</h2>
          </div>
          <img src="/img/Webnet-Logo.png" alt="Logo" className="logo" />

          <div className="divider"><span>OR</span></div>
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="text"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <input
                type="password"
                id="newPassword"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
            <button type="submit" className="btn submit-btn">Submit</button>
          </form>
          <div className="signup-text">
            <p><NavLink to="/signin">Login</NavLink></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
